const carouselResources = {
  en: {
    carousel: {
      title1: 'OGPO VTS',
      description1: 'MANDATORY CAR INSURANCE',
      button1: 'Apply for insurance',
      title2: 'Property insurance',
      description2: 'HOME SECURITY AND RESPONSIBILITY TO NEIGHBORS',
      button2: 'Apply for insurance',
      title3: 'Insurance travel',
      description3: 'CARING FOR YOUR SAFETY',
      button3: 'Apply for insurance',
      title4: 'Choose and issue a CASCO without leaving home',
      description4: 'CAR INSURANCE',
      button4: 'Apply for insurance',
      title5: 'ACCIDENT INSURANCE ',
      description5: 'HEALTH',
      button5: 'Apply for insurance',
      title6: 'Insurance case',
      description6:
        'Leave a request for an insurance case, and we will help you in the near future',
      button6: 'Submit your application',
      title7: 'Insurance entrepreneur',
      description7:
        'This is a highly qualified sales specialist with a free schedule and unlimited earnings. Earn and get a decent reward immediately after registration ',
      button7: 'Become an insurance agent',
    },
  },
  kz: {
    carousel: {
      title1: 'ОГПО ВТС',
      description1: 'МІНДЕТТІ АВТОСАҚТАНДЫРУ',
      button1: 'Сақтандыру рәсімдеу',
      title2: 'Мүлікті сақтандыру',
      description2: 'ҮЙ ҚАУЫПСІЗДІГІ ЖӘНЕ КӨРШІЛЕР АЛДЫНДАҒЫ ЖАУАПКЕРШІЛІК  \n',
      button2: 'Сақтандыру рәсімдеу',
      title3: 'Шетелге саяхат',
      description3: 'СІЗДІҢ ҚАУІПСІЗДІГІҢІЗГЕ ҚАМҚОРЛЫҚ ',
      button3: 'Сақтандыру рәсімдеу',
      title4: 'Үйден шықпай-ақ КАСКО таңдаңыз және безендіріңіз',
      description4: 'АВТОСАҚТАНДЫРУ',
      button4: 'Сақтандыру рәсімдеу',
      title5: 'Жазатайым жағдайлардан сақтандыру',
      description5: 'ДЕНСАУЛЫҚ',
      button5: 'Сақтандыру рәсімдеу',
      title6: 'Сақтандыру жағдайы',
      description6:
        'Сақтандыру жағдайы өтініш қалдырыңыз және сізге жақын арада көмектесеміз',
      button6: 'Өтініш қалдыру',
      title7: 'Сақтандыру кәсіпкері',
      description7:
        'Бұл еркін кестесі және шексіз табысы бар жоғары білікті сату маманы. Тіркелгеннен кейін бірден лайықты сыйақы алыңыз ',
      button7: 'Сақтандыру агенті болу',
    },
  },
  ru: {
    carousel: {
      title1: 'ОГПО ВТС',
      description1: 'ОБЯЗАТЕЛЬНОЕ АВТОСТРАХОВАНИЕ',
      button1: 'Оформить страховку',
      title2: 'Страхование имущества',
      description2: 'БЕЗОПАСНОСТЬ ДОМА И ОТВЕТСТВЕННОСТЬ ПЕРЕД СОСЕДЯМИ ',
      button2: 'Оформить страховку ',
      title3: 'Путешествие за границу',
      description3: 'ЗАБОТА О ВАШЕЙ БЕЗОПАСНОСТИ',
      button3: 'Оформить страховку',
      title4: 'Выберите и оформите КАСКО не выходя из дома',
      description4: 'АВТОСТРАХОВАНИЕ',
      button4: 'Оформить страховку',
      title5: 'Страхование от несчастного случая',
      description5: 'ЗДОРОВЬЕ',
      button5: 'Оформить страховку',
      title6: 'Страховой случай',
      description6:
        'Оставьте заявку на страховой случай, и вам помогут в ближайшее время ',
      button6: 'Оставить заявку',
      title7: 'Страховой предприниматель',
      description7:
        'Это высококвалифицированный специалист по продажам со свободным графиком и неограниченным заработком. Зарабатывай и получай достойное вознаграждение сразу после регистрации',
      button7: 'Стать страховым агентом',
    },
  },
};

export default carouselResources;
